import { render, staticRenderFns } from "./step04.vue?vue&type=template&id=cfb6130e&"
import script from "./step04.vue?vue&type=script&lang=js&"
export * from "./step04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports